/**
 * localStorage Polyfill for Node.js Build Environment
 * 
 * This polyfill MUST be imported before any other code that might access localStorage.
 * It prevents Node.js's webstorage module from being initialized during webpack build.
 * 
 * Import this file at the very top of your entry point (index.js) before any other imports.
 */

(function() {
  'use strict';
  
  // Only run in Node.js environments (build time)
  if (typeof process === 'undefined' || !process.versions || !process.versions.node) {
    return; // Not Node.js, browser will handle localStorage normally
  }
  
  // We're in Node.js - check if window exists (webpack/html-webpack-plugin environment)
  if (typeof window === 'undefined') {
    return; // No window object, nothing to do
  }
  
  // Create a localStorage stub that mimics the Storage API
  const localStorageStub = {
    _data: {},
    getItem: function(key) {
      return this._data[String(key)] || null;
    },
    setItem: function(key, value) {
      try {
        this._data[String(key)] = String(value);
      } catch (e) {
        // Ignore quota errors in stub
      }
    },
    removeItem: function(key) {
      delete this._data[String(key)];
    },
    clear: function() {
      this._data = {};
    },
    get length() {
      return Object.keys(this._data).length;
    },
    key: function(index) {
      const keys = Object.keys(this._data);
      return index >= 0 && index < keys.length ? keys[index] : null;
    }
  };
  
  // Try to override window.localStorage before any code accesses it
  // We use a Proxy-based approach to intercept ALL access, including getter calls
  try {
    // Check if property exists using 'in' operator (doesn't trigger getter)
    const propertyExists = 'localStorage' in window;
    
    if (propertyExists) {
      // Property exists - we need to be careful not to trigger it
      // Use defineProperty with a getter that returns our stub
      // This intercepts all access attempts
      try {
        Object.defineProperty(window, 'localStorage', {
          get: function() {
            return localStorageStub;
          },
          set: function(value) {
            // Ignore attempts to set it
          },
          configurable: false,
          enumerable: true
        });
      } catch (e) {
        // If we can't redefine it (not configurable), try using a Proxy wrapper
        // But we can't do this without accessing the original, so we'll just let it fail
        // Our code will handle it with safe checks
      }
    } else {
      // Property doesn't exist - create it directly
      Object.defineProperty(window, 'localStorage', {
        value: localStorageStub,
        writable: false,
        configurable: false,
        enumerable: true
      });
    }
  } catch (e) {
    // If all else fails, try direct assignment (might trigger getter, but we're in a catch)
    try {
      window.localStorage = localStorageStub;
    } catch (e2) {
      // Can't set it - that's okay, our safe checks will handle it
    }
  }
})();

// Export nothing - this is a side-effect only module
export {};

